import { Button, ButtonsGroup, Modal, ModalProps, Text, useModal } from '@billy/design-system'
import { ReactElement } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { ModalId } from '../../../../../../enums/modalId'

export const BankConnectionFailedModal = ({ ...modalProps }: ModalProps): ReactElement => {
  const { t } = useTranslation()
  const { close: closeModal } = useModal(ModalId.BankConnectionFailedModal)
  return (
    <Modal size="s" {...modalProps}>
      <Modal.Header>
        <Text variant="h2">{t('bank_connection.connection_failed.title')}</Text>
      </Modal.Header>
      <Modal.Body>
        <Text>
          <Trans i18nKey="bank_connection.connection_failed.text" />
        </Text>
      </Modal.Body>
      <Modal.Footer>
        <ButtonsGroup>
          <Button onClick={closeModal} variant="filled">
            {t('ok')}
          </Button>
        </ButtonsGroup>
      </Modal.Footer>
    </Modal>
  )
}
